import { useNavigate } from 'react-router-dom';
import { HouseDivider } from '../components/HeroIcons';

export default function About() {
  const navigate = useNavigate();

  return (
    <div className="page-wrap" style={{ background: '#F5EFE3' }}>

      {/* Hero */}
      <div style={{ padding: 'clamp(40px, 8vw, 64px) 16px 24px', textAlign: 'center' }}>
        <div style={{ fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#B8893A', marginBottom: 12, fontWeight: 600 }}>
          About RenterRep
        </div>
        <h1
          style={{
            fontFamily: "'DM Serif Display', serif",
            fontSize: 'clamp(28px, 5.5vw, 48px)',
            color: '#0F2C4E',
            letterSpacing: '-0.02em',
            lineHeight: 1.15,
            margin: 0,
            fontWeight: 400,
            maxWidth: 1100,
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: '0 8px',
          }}
        >
          <span style={{ display: 'block', whiteSpace: 'nowrap' }}>Credit reports tell you their history.</span>
          <span style={{ display: 'block', color: '#C9972A' }}>RenterRep tells you their story.</span>
        </h1>
        <HouseDivider width={320} />
        <p style={{ fontSize: 14, color: '#6B6358', maxWidth: 560, margin: '0 auto' }}>
          The only rental review platform that rates <em>both</em> sides, tenants and property management.
        </p>
      </div>

      {/* Founder / mission */}
      <div style={{ padding: '12px 16px 24px' }}>
        <div
          style={{
            maxWidth: 720,
            margin: '0 auto',
            background: '#FAF6EC',
            borderRadius: 20,
            border: '1px solid rgba(184,137,58,0.18)',
            padding: 'clamp(24px, 5vw, 36px)',
            boxShadow: '0 4px 16px rgba(120,90,30,0.08)',
          }}
        >
          <h2
            style={{
              fontFamily: "'DM Serif Display', serif",
              fontSize: 'clamp(22px, 4.5vw, 28px)',
              color: '#0F2C4E',
              fontWeight: 400,
              marginBottom: 14,
              textAlign: 'center',
            }}
          >
            Why we built this
          </h2>
          <p style={{ fontSize: 13, color: '#B8893A', letterSpacing: '0.06em', textAlign: 'center', fontWeight: 600, marginBottom: 20, marginTop: -8 }}>
            Bridging the gap between property management and tenants.
          </p>
          <p style={{ fontSize: 15, color: '#2C2C2C', lineHeight: 1.7, marginBottom: 16 }}>
            Renting is one of the largest financial decisions most people make, yet it is
            routinely made with incomplete information on both sides. Tenants sign year-long
            leases without knowing how a property management handles maintenance, deposits, or disputes.
            Property Management hand over keys without knowing whether an applicant pays on time,
            respects the property, or honors their commitments.
          </p>
          <p style={{ fontSize: 15, color: '#2C2C2C', lineHeight: 1.7, marginBottom: 16 }}>
            Credit reports show payment history. They do not show conduct. RenterRep bridges
            the gap with verified reviews from both sides of every lease, giving
            renters and property management the context that contracts and credit scores cannot.
          </p>
          <p style={{ fontSize: 15, color: '#2C2C2C', lineHeight: 1.7, marginBottom: 0 }}>
            Writing a review is free. Reading a review is not.
          </p>
        </div>
      </div>

      {/* Values strip */}
      <div style={{ padding: '24px 16px 40px' }}>
        <div
          className="about-values-grid"
          style={{
            maxWidth: 720,
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: 14,
          }}
        >
          {[
            { title: 'Both sides', body: 'Every transaction has two parties. So does every review system on RenterRep.' },
            { title: <>Free to review...<br/>Pay to preview</>, body: 'Posting reviews is always free — for tenants and property management alike, on every tier, forever. Reading other people’s reviews is what we charge for.' },
            { title: 'Transparent', body: 'Verified reviews, no pay-to-suppress, no anonymous attacks.' },
          ].map((v, i) => (
            <div
              key={i}
              style={{
                background: '#FAF6EC',
                borderRadius: 14,
                border: '1px solid rgba(184,137,58,0.18)',
                padding: '16px 18px',
              }}
            >
              <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 17, color: '#0F2C4E', marginBottom: 6 }}>
                {v.title}
              </div>
              <div style={{ fontSize: 13, color: '#6B6358', lineHeight: 1.55 }}>
                {v.body}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div style={{ padding: '0 16px 56px', textAlign: 'center' }}>
        <p style={{ fontSize: 14, color: '#6B6358', marginBottom: 14 }}>
          Questions, partnerships, or press? <a href="mailto:support@renterrep.com" style={{ color: '#0F2C4E', textDecoration: 'underline' }}>support@renterrep.com</a>
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => navigate('/signup')} style={{ background: '#0F2C4E', color: '#fff', border: 'none', padding: '12px 28px', borderRadius: 50, fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
            Sign Up Free
          </button>
          <button onClick={() => navigate('/')} style={{ background: 'transparent', color: '#0F2C4E', border: '1.5px solid #0F2C4E', padding: '12px 28px', borderRadius: 50, fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>
            Back to home
          </button>
        </div>
      </div>

    </div>
  );
}
